import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { unformatted_amount } from 'helpers/number'
import { get_bid_message } from 'reducers/AuctionReducer'
import { general_error_toastr } from 'components/partials/Notification'
import { is_user_suspended } from 'helpers/user'
import NavLink from 'components/Page/NavLink'
import { loginLink } from 'helpers/page'
import Button from 'components/partials/Fields/Button'
import UserBannedTooltip from 'components/UserBannedTooltip'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import './styles.scss'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalBody from 'react-bootstrap/ModalBody'

const AuctionBidBoxComponent = (props) => {
    const {
        auction,
        isPlacingBid,
        typedBidAmount,
        handleTypedBidAmount,
        showToastr,
        toggleAuctionWatch,
        handleNotificationState,
        openConfirmModal,
        handleBidConfirmed,
        auctionDetailsPage = false,
        postReview = false,
        auctionId,
        user,
        resetBidValue = false,
        canBid: _canBid = true
    } = props

    const {
        status_id: statusId = false,
        total_views: totalViews = 0,
        total_bids: totalBids = 0,
        initial_bid: initialBid = 0,
        minimum_bid: minimumBid = 0,
        current_bid,
        facility,
        upcoming: comingSoon,
        user: auctionUser,
        user: { watchlist = false } = {},
        user: { is_high_bidder: isHighBidder = false } = {}
    } = auction

    const [enteredBid, setEnteredBid] = useState('')
    const [showMaxBidModal, setShowMaxBidModal] = useState(false)
    const authed = user.authed

    const getMinimumBidAmount = () => {
        return totalBids === '0' ? unformatted_amount(initialBid) : unformatted_amount(minimumBid)
    }

    const bid_confirmed = (userMaxBid) => {
        const intNewUserMaxBid = parseInt(userMaxBid)
        const intAuctionMinimumBidAmount = parseInt(getMinimumBidAmount())

        const minAcceptableBid = isHighBidder ? parseInt(unformatted_amount(current_bid)) : intAuctionMinimumBidAmount

        if (!intNewUserMaxBid || intNewUserMaxBid < minAcceptableBid) {
            const message = get_bid_message('nobid-minimum')
            showToastr(message)
            return false
        }

        if (intNewUserMaxBid % 10) {
            const message = get_bid_message('bid-increment')
            showToastr(message)
            return false
        }

        if (userMaxBid.includes('.')) {
            general_error_toastr({
                title: 'Your Bid Was Unsuccessful.',
                message: 'Your bid must be a whole number.'
            })
            return false
        }

        if (statusId !== '1') {
            const notification = get_bid_message('auction-expired', false)

            handleNotificationState(notification)

            openConfirmModal()

            return false
        }

        handleBidConfirmed(intNewUserMaxBid)
    }

    const openModal = () => {
       setShowMaxBidModal(true)
    }

    const renderActive = () => {
        const { reg_type } = user
        let headerText = 'Ready to Bid?'
        let buttonText = 'Confirm Bid Now'
        let headerTextAdditional = ''
        const isBidder = auctionUser.is_bidder
        const isSuspended = is_user_suspended()
        const isBanned = facility?.user?.banned

        const canBid = !isSuspended && !isBanned && _canBid

        const isSuspendedClass = !canBid ? ' disabled' : ''

        const onChange = ({value: typedBidAmount}) => handleTypedBidAmount(typedBidAmount)

        if (isPlacingBid === true) {
            buttonText = (
                <span>
                    <i className="fa fa-spin fa-spinner" />
                    {' '}
                    Placing Bid
                </span>
            )
        }

        if (isBidder && isHighBidder) {
            headerText = 'Update Your Max Bid'
            buttonText = 'Confirm Bid Now'
            headerTextAdditional = (
                <div style={{ fontSize: 14, fontWeight: 400 }}>
                    Your current max bid on this auction is
                    {' '}
                    <strong>{auctionUser.max_bid.formatted}</strong>
                </div>
            )

            if (isPlacingBid === true) {
                buttonText = (
                    <span>
                        <i className="fa fa-spin fa-spinner" />
                        {' '}
                        Updating Bid
                    </span>
                )
            }
        }

        if (comingSoon && authed) {
            return (
                <>
                    <div key="bidding-title" className="auction-bidding-title text-center">Come back soon!</div>
                    <div key="bidding-coming-soon" className="auction-bidding-coming-soon-text text-center">
                        This auction hasn't started yet.
                        {reg_type === '1' || ' Make sure to add it to AuctionWatch so you don\'t miss the action!'}
                    </div>
                    <div key="bidding-section" className="bidding-buttons bidding-buttons-soon text-center">
                        {
                            reg_type === '1' || (
                                <Button
                                    label={watchlist ? 'Remove from AuctionWatch' : 'Add to AuctionWatch'}
                                    className="btn btn-orange btn-regular btn-lg"
                                    onClick={toggleAuctionWatch}
                                />
                            )
                        }
                        <NavLink to="/auctions" className="btn btn-blue btn-regular" title="Browse Other Auctions">Browse Other Auctions</NavLink>
                    </div>
                </>
            )
        } else if (comingSoon && !authed) {
            return (
                <>
                    <div key="bidding-title" className="auction-bidding-title text-center">Come back soon!</div>
                    <div key="bidding-coming-soon" className="auction-bidding-coming-soon-text text-center">This auction hasn't started yet. Log in to add it to AuctionWatch so you don't miss the action!</div>
                    <Row key="bidding-section" className="bidding-buttons text-center">
                        <Col xs={12} sm={6}>
                            <NavLink to="/register" className="btn btn-orange btn-regular" id="auction-bid-box-sign-up" title="Sign Up">Sign Up</NavLink>
                        </Col>
                        <Col xs={12} sm={6}>
                            <NavLink to={loginLink()} className="btn btn-blue btn-regular" id="auction-bid-box-login" title="Log In">Log In</NavLink>
                        </Col>
                        <div className="clearfix" />
                    </Row>
                </>
            )
        } else if (authed && (reg_type === '1' || reg_type === '4')) {
            return (
                <div key="bidding-title" className="auction-bidding-title text-center">
                    You must be logged in as a buyer to bid.
                </div>
            )
        } else if (authed) {

            return (
                <form
                    noValidate
                    onSubmit={(e) => {
                        e.preventDefault()
                        if (canBid === false) {
                            // general_error_toastr({message: "Suspended account"})
                            return false
                        }
                        bid_confirmed(enteredBid)
                    }}
                >
                    <div key="bidding-title" className="auction-bidding-title text-center">
                        {headerText}
                        {headerTextAdditional}
                    </div>

                    <Row key="bidding-section" className="marginT15 marginB10">
                        <Col className="text-center max-bid-help">
                            Enter Max Bid (
                            {facility.currency_code}
                            )
                            <a className="max-whats-this" onClick={openModal}>
                                What's this?
                            </a>
                        </Col>

                        <Col className="">
                            <div className="bid-input-wrapper">
                                <div className="bid-input input-group input-group-lg">
                                    <div className="input-group-addon">$</div>
                                    <input
                                        type="number"
                                        readOnly={!canBid}
                                        disabled={!canBid}
                                        style={{ minWidth: 100 }}
                                        step="10"
                                        min={undefined}
                                        className={`form-control key-numeric ${isSuspendedClass}`}
                                        id="bid_amount"
                                        name="bid_amount"
                                        autoFocus={false}
                                        value={typedBidAmount}
                                        onChange={({ target }) => {
                                            setEnteredBid(target.value)
                                            onChange(target)
                                        }}
                                    />
                                    <div className="input-group-addon">.00</div>
                                </div>
                            </div>
                        </Col>

                        <Col className="confirm-button-container">
                            <UserBannedTooltip show={isBanned}>
                                <button type="submit" disabled={isPlacingBid} className={`confirm-button btn btn-regular btn-blue ${isSuspendedClass}`}>
                                    {buttonText}
                                </button>
                            </UserBannedTooltip>
                        </Col>
                    </Row>
                    <Row className="text-center bottom-instruction">
                        <Col>
                            Current Minimum
                            Bid:
                            {' '}
                            {totalBids == 0 ? initialBid.formatted : minimumBid.formatted}
                        </Col>
                    </Row>
                    <Modal show={showMaxBidModal} onHide={() => setShowMaxBidModal(false)}>
                        <ModalHeader closeButton>
                            <ModalTitle>
                                <h4 className="modal-title">How the "Max Bid" System Works</h4>
                            </ModalTitle>
                        </ModalHeader>
                        <ModalBody>
                            The StorageTreasures auction system accepts bids in increments of $10 ($10, $20, and so on). If you prefer, you can monitor auctions very closely and respond to the bids of other
                            buyers in real time. However, you also have the option to use a Proxy Bidding strategy. If you already know the maximum bid that you are willing to submit, you can enter the entire
                            amount in advance, and your maximum bid - which is NOT visible to other buyers - is committed to bids in the smallest possible increments so that you may not need to pay out the entire
                            amount to win an auction.
                            <br />
                            <br />
                            For example, if the high bid for an auction is currently $30, and you decide to make your Maximum Bid $100, your initial bid is really only for $40, with the remaining $60 held in
                            reserve, to be used if needed. So if another buyer then bids $50, your bid is automatically increased to $60. If that turns out to be the winning bid, then the other $40 you had in
                            reserve is not applied - and yours to keep. Otherwise, you are only notified of other bids if and when another buyer exceeds your max bid. Using a Proxy Bidding strategy is a good way
                            to participate in more auctions with the least amount of bid tracking!
                        </ModalBody>
                    </Modal>
                </form>
            )
        } else {
            return (
                <>
                    <div key="bidding-title" className="auction-bidding-title text-center">Ready to bid?</div>
                    <Row key="bidding-section" className="bidding-buttons text-center d-flex justify-content-around">
                        <Col xs={12} sm={6}>
                            <NavLink to="/register" className="btn btn-orange btn-regular" id="auction-bid-box-sign-up" title="Sign Up">Sign Up</NavLink>
                        </Col>
                        <Col xs={12} sm={6}>
                            <NavLink to={loginLink()} className="btn btn-blue btn-regular" id="auction-bid-box-log-in" title="Log In">Log In</NavLink>
                        </Col>
                    </Row>
                </>
            )
        }

    }

    const renderInactive = (title) => {
        return (
            <>
                <div key="bidding-title" className="auction-bidding-title text-center">{title}</div>
                <div key="bidding-section" className="text-center">
                    <NavLink to="/auctions" className="btn btn-blue btn-regular margin10" title="Browse other auctions">Browse other auctions</NavLink>
                </div>
            </>
        )
    }

    const renderBiddingSection = () => {
        switch (statusId) {
            case '1':
                return renderActive()
            case '2':
                //Sold
                return renderInactive('This auction has ended.')
            case '3':
                //Unsold
                return renderInactive('This auction has ended with no bids')
            case '4':
            case '5':
                //Canceled
                return renderInactive('This auction has been canceled')
            default:
                return null
        }
    }

    const getBiddingContainerSize = () => {
        if (authed && !comingSoon) {
            return 'auction-bidding-lg'
        }
        return 'auction-bidding'
    }

    const renderBidBox = () => {
        return (
            <div className={`auction-bidding-wrapper ${getBiddingContainerSize()}`}>
                {renderBiddingSection()}
            </div>
        )
    }

    useEffect(() => {
        if (resetBidValue) {
            setEnteredBid('')
        }
    }, [resetBidValue])

    const renderTitle = () => {
        if (postReview) {
            return auctionId ? 'This is an active auction.' : 'This auction has not begun yet.'
        } else {
            switch (statusId) {
                case '1':
                    return 'This is an active auction.'
                case '2':
                    //Sold
                    return 'This auction has ended.'
                case '3':
                    //Unsold
                    return 'This auction has ended with no bids.'
                case '4':
                case '5':
                    //Canceled
                    return 'This auction has been canceled.'
                default:
                    return 'This auction has ended.'
            }
        }
    }

    return (
        <Col md={12} className="auction-bidding-container">
            <Row className="m-0">
                {auctionDetailsPage ? (
                    renderBidBox()
                ) : (
                    <div className="auction-bidding-wrapper auction-bidding">
                        <div className="auction-bidding-title text-center">
                            {renderTitle()}
                        </div>
                    </div>
                )}
            </Row>
            <Row className="m-0">
                <Col xs={6} className="small my-3 total-bids">
                    <strong>Bids on this unit: </strong>
                    {' '}
                    {totalBids}
                </Col>
                <Col xs={6} className="small my-3 total-views">
                    <strong>Visitors to this page: </strong>
                    {' '}
                    {totalViews}
                </Col>
            </Row>
        </Col>
    )
}

const mapStateToProps = ({ user }) => ({
    user
})

export default connect(mapStateToProps)(AuctionBidBoxComponent)
